import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionPlacementType,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';

export class OwnershipAnalysisCommentsConfiguration extends ReportSectionConfigurationBase {
  typeName = 'OwnershipAnalysisCommentsConfiguration';
  readonly reportSection = ReportSection.OwnershipAnalyticsComments;
  nodataLocalizationKeyName = 'commentary';
  override disabledLayoutWidthControl = true;
  override readonly placementType = ReportSectionPlacementType.Static;
  readonly name = 'ownershipAnalyticsComments';
  readonly displayName = 'Comments';
  readonly reportViewModelSections = [ReportViewModelSection.OwnershipAnalyticsReport_Comments];
  readonly minSize = 1;
  readonly maxSize = 4;
  readonly defaultSize = 4;
  readonly applicableReportTypes = [ReportType.OwnershipAnalyticsReport];
  override get requirePostDataInput(): boolean {
    return true;
  }
  readonly availableDataSections = [];
}
